// extracted by mini-css-extract-plugin
export default {"root":"tpnxTFeROsTGQUbYClAu","icon":"MZoF7CBMMqtcGRtbhvzF","normal":"bGeCBaIuuJqE6VWtfDdF","btnDisabled":"w8xxlhjk7TrZjlaaXZW7","panel":"FN7XMLTgb8Fwep3g1z_g"};